import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

import BasicGrid from '../../components/Grid/Basic';
import {
  dateFormatter,
  downloadBlob,
  modifyFields,
} from '../../helpers/utilities';
import { useNavigate } from 'react-router-dom';
import { projectsGridConfig, gridResponse } from './config';
import {
  fetchProjectsData,
  getPageParams,
  getSearchData,
  getSearchStatus,
  resetSearchDataReducer,
  setPageParams,
  setSearchParams,
} from '../../app/projects/searchProjectSlice';

export default function ProjectListGrid(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showDetails, setShowDetails] = useState({ show: false });
  const [fields, setFields] = useState([]);
  const [title, setTitle] = useState(props.isEnrollmentView ? 'Pending Enrollments':'Projects');
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(projectsGridConfig.pageSize);
  const isGridLoading = useSelector(getSearchStatus);
  const searchResult = useSelector(getSearchData);
  const pageData = useSelector(getPageParams);

  const projectsDetails = gridResponse;
  const scrollTop = () => window.scrollTo(0, 0);

  useEffect(() => {
    if (projectsDetails.field && fields.length === 0) {
      setFields(
        modifyFields(
          projectsDetails.field,
          projectsGridConfig.projectGridHeader,
          projectsGridConfig.schema,
          projectsGridConfig.gridName
        )
      );
    }
  }, [projectsDetails, projectsGridConfig]);

  useEffect(() => {
    return () => {
      dispatch(resetSearchDataReducer());
    };
  }, []);

  useEffect(() => {
    if (
      pageData.page === 1 &&
      pageData.pageSize === projectsGridConfig.pageSize
    ) {
      setPage(1);
      setPageSize(projectsGridConfig.pageSize);
    }
  }, [pageData]);

  useEffect(() => {
    if (searchResult && searchResult?.totalRows !== 0) {
      setTotalRows(searchResult?.totalRows);
    }
  }, [searchResult]);

  useEffect(() => {
    const colDef = _.map(fields, (ele) =>
      _.omit(ele, ['cellRenderer', 'filter', 'valueFormatter'])
    );
    //dispatch(setColDef(colDef));
  }, [fields]);

  const handlePageChange = (value) => {
    setPage(value);
    dispatch(
      setPageParams({ page: Number(value), pageSize: Number(pageSize) })
    );
    dispatch(fetchProjectsData(props.searchParams));
    scrollTop();
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setPage(1);
    dispatch(setSearchParams(props.searchParams));
    dispatch(setPageParams({ page: 1, pageSize: Number(value) }));
    dispatch(fetchProjectsData(props.searchParams));
    scrollTop();
  };

  const handleCellClicked = (col, value, data) => {
    if (col === 'view' || col === 'edit') {
      props.setShowProjectView({ show: true, data: data, btnType: col });
    }
  };

  return (
    <>
      {searchResult?.appSummaries?.length > 0 && (
        <BasicGrid
          fields={fields}
          data={searchResult?.appSummaries || []}
          title={title}
          isDataLoading={isGridLoading === 'idle' ? false : true}
          onPageChange={(e) => handlePageChange(e)}
          onPageSizeChange={(e) => handlePageSizeChange(e)}
          page={page}
          pageSize={pageSize}
          totalRows={totalRows}
          onCellClicked={(col, value, data) =>
            handleCellClicked(col, value, data)
          }
        />
      )}
      {searchResult?.appSummaries?.length === 0 && (
        <div style={{ textAlign: 'center' }}>No Results Found</div>
      )}
    </>
  );
}
